import DialogSearch from "../DialogSearch";
import TileHcpcsCode from "../../Tile/TileHcpcsCode";
import PropTypes from "prop-types";
import HcpcsCode from "../../../Utility/Crud/HcpcsCode";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchHcpcsCode extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for hcpcs codes by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered hcpcs codes.
     */
    getSearchResults(query) {
        return HcpcsCode.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.hcpcsCodesIndexed);
        }
    }

    /**
     * @param {object} hcpcsCode The hcpcsCode object.
     * @returns A TileHcpcsCode component for this hcpcsCode.
     */
    renderTile(hcpcsCode) {
        return (
            <TileHcpcsCode
                key={ hcpcsCode.id }
                hcpcsCode={ hcpcsCode }
            />
        );
    }
}
